module.exports = __webpack_public_path__ + "img/1.71d9b7c5.png";